const verification = {
  success: 'Vérifié avec succès',
  warning:
    'Vous devez confirmer votre adresse email pour pouvoir consulter votre profil.',
}

export default verification
